// import PosCartActions from '../../../actions/PosCartActions';
// import NotificationActions from '../../../actions/NotificationActions';

class PromptCouponValue extends React.Component {

    // constructor(props) {
    //     super(props);

    //     this.state = {
    //         quantity        : 1,
    //         pricePerItem    : this.props.item.UnitPrice,
    //         discountAmount  : 0,
    //         itemTotalPrice  : this.props.item.UnitPrice
    //     };

    //     this.increaseByQty = this.increaseByQty.bind(this);
    //     this.updateTotal = this.updateTotal.bind(this);
    // }

    // updateTotal() {
    //     this.setState({
    //         itemTotalPrice : this.state.quantity * this.state.pricePerItem
    //     });
    // }

    // increaseByQty() {
    //     var item = this.props.item;
    //     var quantity = parseInt(this.state.quantity);

    //     if (!quantity || quantity.length < 1 || quantity === 0)
    //         return;

    //     if (this.state.quantity > item.TotalAvailable) {
    //         NotificationActions.addNotification({
    //             type : 'alert',
    //             body : 'Only '+item.TotalAvailable+' left'
    //         });
    //     } else {

    //         var tmpItem = this.props.item;
    //         tmpItem.DiscountAmount = this.state.discountAmount;
    //         tmpItem.UnitPrice      = this.state.pricePerItem;

    //         PosCartActions.addItemToCart(tmpItem, this.props.guest, this.state.quantity);
    //         this.props.onClose();
    //     }
    // }

    render() {
        var self = this;

        var item      = this.props.item;
        var guest     = this.props.guest;

        return (

            <div className='popup popup__transparent'>
                <div className='popup__content increase__last-four'>
                    <div className='popup-header'>
                        COUPON VALUE

                        <div
                            className='popup-close'
                            onClick={() => { self.props.onClose(); }}>

                            <i className='fa fa-times' aria-hidden='true' />
                        </div>
                    </div>

                    <input
                        type='text'
                        id='couponValue' />

                    <div
                        className='increase__last-four--go'
                        onClick={() => { this.props.increase() }}>

                        OK
                    </div>
                </div>

            </div>
        );
    }
}

export default PromptCouponValue;


// WEBPACK FOOTER //
// ./ui_src/app/components/pos/selected/PromptCouponValue.react.jsx